export default __webpack_public_path__ + "static/Dealerships-f7c2cbc8fa1d983ef6f70e02bb5d2156.jpg";